import { Option } from "@storeblocks/select";
import { RentalProductIntroFormValues } from "./rentalFormValuesInterfaces";
import { MonthlyRental } from "./rentalTypes";

export const getInitialIntroStepFormState =
  (): Partial<RentalProductIntroFormValues> => {
    return {
      postNumber: undefined,
      city: undefined,
      validPostNumber: undefined,
      monthlyRent: undefined,
      huseierneMembershipStatus: undefined,
    };
  };

export const getMonthlyRentalOptions = (): Option[] => {
  return [
    { label: "Velg et alternativ", value: "" },
    { label: "0 - 10 000", value: MonthlyRental.ONE },
    { label: "10 000 - 15 000", value: MonthlyRental.TWO },
    { label: "15 000 - 20 000", value: MonthlyRental.THREE },
    { label: "20 000 - 30 000", value: MonthlyRental.FOUR },
    { label: "30 000 - 40 000", value: MonthlyRental.FIVE },
  ];
};
